// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/terms-and-conditions/terms-and-conditions-modal/terms-and-conditions-modal.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/terms-and-conditions/terms-and-conditions-modal/terms-and-conditions-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;ACCF","sourcesContent":[".modal {\r\n  overflow-y: auto;\r\n}\r\n",".modal {\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
